var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0314 27.3333C38.9947 27.3367 38.276 27.428 37.4074 27.578C34.842 28.0247 34.3747 28.9627 34.3747 30.6913V33.3333H40.3747V34.6667H34.1467H31.2467C29.4894 34.6667 27.9514 35.4947 27.464 37.4793C26.9134 39.7573 26.8887 41.184 27.464 43.5627C27.9007 45.3367 28.8627 46.6667 30.6207 46.6667H33.042V43.264C33.042 41.2867 34.8327 39.3333 36.8847 39.3333H41.7087C43.3907 39.3333 45.042 38.092 45.042 36.4153V30.6913C45.042 29.0653 43.8694 27.8493 42.23 27.5767C42.2707 27.5727 41.0594 27.3293 40.0314 27.3333ZM36.7087 30C37.256 30 37.7087 30.4513 37.7087 31.0013C37.7087 31.5567 37.256 32 36.7087 32C36.1507 32 35.7087 31.5573 35.7087 31.0013C35.7087 30.4533 36.1507 30 36.7087 30Z",
    fill: "#0277BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3853 52.6667C40.422 52.6633 41.1406 52.572 42.0093 52.422C44.5746 51.9753 45.042 51.0373 45.042 49.3087V46.6667H39.042V45.3333H45.2706H48.1706C49.928 45.3333 51.466 44.5053 51.9533 42.5207C52.504 40.2427 52.5286 38.816 51.9533 36.4373C51.516 34.6633 50.554 33.3333 48.796 33.3333H46.3746V36.736C46.3746 38.7133 44.584 40.6667 42.532 40.6667H37.708C36.026 40.6667 34.3746 41.908 34.3746 43.5847V49.3087C34.3746 50.9347 35.5473 52.1507 37.1866 52.4233C37.146 52.4273 38.3573 52.6707 39.3853 52.6667ZM42.7086 50C42.1613 50 41.7086 49.5487 41.7086 48.9987C41.7086 48.4433 42.1613 48 42.7086 48C43.2666 48 43.7086 48.4427 43.7086 48.9987C43.7086 49.5467 43.266 50 42.7086 50Z",
    fill: "#FFC107"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.4a37e72464ee8f4298b4232ea14fa71f.svg";
export { ForwardRef as ReactComponent };